import { logGraphQLOperation } from "../logging/GraphQLOperationLogging";
import { getCachedTareData } from "../native-modules/tare/TareDataCache";

import { ApolloLink, Observable } from "@apollo/client";

function extractSubApp(context: unknown): string | null {
  if (context == null || typeof context !== "object") return null;
  const { headers } = context as Record<string, unknown>;
  if (headers == null || typeof headers !== "object") return null;
  const value = (headers as Record<string, unknown>)["indeed-client-sub-app"];
  return typeof value === "string" ? value : null;
}

export function createGraphQLOperationLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const startTime = Date.now();

    const subApp = extractSubApp(operation.getContext());
    const operationName = operation.operationName ?? null;

    return new Observable((observer) => {
      const subscription = forward(operation).subscribe({
        next: (result) => {
          const durationMs = Date.now() - startTime;
          const ctk = getCachedTareData()?.deviceModel?.ctk ?? null;
          const gqlErrors = result.errors;
          const hasErrors = Array.isArray(gqlErrors) && gqlErrors.length > 0;
          logGraphQLOperation({
            subApp,
            operationName,
            durationMs,
            success: true,
            errorMessage: hasErrors
              ? gqlErrors.map((e: { message: string }) => e.message).join("; ")
              : undefined,
            ctk,
          });
          observer.next(result);
        },
        error: (err: Error) => {
          const durationMs = Date.now() - startTime;
          const ctk = getCachedTareData()?.deviceModel?.ctk ?? null;
          logGraphQLOperation({
            subApp,
            operationName,
            durationMs,
            success: false,
            errorMessage: err?.message,
            ctk,
          });
          observer.error(err);
        },
        complete: () => {
          observer.complete();
        },
      });

      return () => subscription.unsubscribe();
    });
  });
}
